import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { STACK_ROLE_BINDING_BATCH_CREATE } from "./gql";

const useStackRoleBindingBatchCreate = createDefaultMutationHook(STACK_ROLE_BINDING_BATCH_CREATE);

export default useStackRoleBindingBatchCreate;
